import { useEffect, useRef } from "react";
import { ColorType, createChart, LineSeries, type UTCTimestamp } from "lightweight-charts";

export function EquityChart({
  points,
}: {
  readonly points: readonly { readonly at: string; readonly equityUsd: string }[];
}) {
  const container = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = container.current;
    if (element === null || points.length === 0) return;
    const chart = createChart(element, {
      autoSize: true,
      height: 200,
      layout: { background: { type: ColorType.Solid, color: "#091c15" }, textColor: "#afc7bd" },
      timeScale: { timeVisible: true },
    });
    const series = chart.addSeries(LineSeries, { color: "#6de4b2" });
    // Chart timestamps use seconds; preserve the last value for duplicate seconds.
    const values = new Map<number, number>();
    for (const point of points)
      values.set(Math.floor(Date.parse(point.at) / 1000), Number(point.equityUsd));
    series.setData(
      [...values]
        .sort(([left], [right]) => left - right)
        .map(([time, value]) => ({ time: time as UTCTimestamp, value })),
    );
    chart.timeScale().fitContent();
    return () => chart.remove();
  }, [points]);
  return (
    <section className="section-stack" aria-label="Equity curve for the full backtest period">
      <h2>Equity curve · full backtest period</h2>
      <p className="field-hint">
        {points.length} stored equity points · first ${points[0]?.equityUsd ?? "—"} · last $
        {points.at(-1)?.equityUsd ?? "—"}. These are the saved equity values, not live account
        equity.
      </p>
      <div ref={container} />
    </section>
  );
}
